import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType, defineAsyncComponent, AsyncComponentLoader } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkPage',
  props: {
  name: {
    type: String,
    required: true,
  },
  component: {
    type: Function as PropType<AsyncComponentLoader>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const currentRoute = useRoute()


const AsyncComp = typeof props.component === 'function' ? defineAsyncComponent(props.component) : props.component
const showComponent = computed(() => props.name === currentRoute.name)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showComponent))
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(AsyncComp)), { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}
}

})